import themeLanguage from './themeLanguage.json'
import componentsLanguage from './componentsLanguage.json'
import componentNames from './componentNames.json'
import errors from './errors.json'
import mobligoLanguage from './mobligoLanguage.json'
import serverErrors from './serverErrors.json'
import statusCodes from './statusCodes.json'
const language = {
    ...themeLanguage,
    ...componentsLanguage,
    ...errors,
    ...componentNames,
    ...mobligoLanguage,
    ...serverErrors,
    ...statusCodes
}
export const translate = (key) => {

    const keyString = String(key)
    const translated = language[keyString]
    if (translated) return translated

    const keyArray = keyString && keyString.split(".")
    if (!keyArray) return keyString
    let foundText
    for (let i = 0; i < keyArray.length; i++) {
        keyArray.shift()
        const nameToCheck = language[keyArray.join(".")]
        if (nameToCheck) {
            foundText = nameToCheck
            break
        }

    }

    return foundText || key
}